export default __webpack_public_path__ + "static/media/Jovian Battle Cape.d0cf9495.jpg";